import React, { Component } from "react";
import "./ProductSourcesDetail.scss";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IOnTypeaheadCatalogItemDTO from "../../../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import ITypeaheadCatalogItemDTO from "../../../../../models/DTO/ITypeaheadCatalogItemDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalog_Item from "../../../../../models/ICatalog_Item";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import OwButton from "../../../../shared/OwButton/OwButton";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";
import ICatalog from "../../../../../models/ICatalog";

type Props = {
    socket: Socket;
    notify: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    catalogGuid: string;
    productSources: ICatalog_Item[];
    updateProductSourcesFn: (sources: ICatalog_Item[]) => void;
    catalogModel: ICatalog;
};

type State = {
    typeaheadItems: ICatalog_Item[];
    selectedProductSource?: ICatalog_Item;
    productSources: ICatalog_Item[];
    // qtySet: { material: IMaterial; qty: number }[];
    clearTypeahead: boolean;
};

class ProductSourcesDetail extends Component<Props, State> {
    readonly state: State = {
        typeaheadItems: [],
        productSources: this.props.productSources,
        clearTypeahead: false,
    };

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (!this.state.productSources.length && this.props.productSources.length) {
            this.setState({
                productSources: this.props.productSources,
            });
        }
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
    }

    typeaheadProductSources = (name: string) => {
        const payload: ITypeaheadCatalogItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            catalogGuid: this.props.catalogGuid,
            onlyAlternateSources: true,
            onlyActive: true,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            typeaheadItems: data.catalog_items,
        });
    };

    selectedItem = (productSource: ICatalog_Item) => {
        this.setState({
            selectedProductSource: productSource,
        });
    };

    addSelectedItem = () => {
        if (this.state.selectedProductSource) {
            const productSources = this.state.productSources;

            productSources.push(this.state.selectedProductSource);

            console.log("productSources", productSources);

            this.setState(
                {
                    productSources,
                    selectedProductSource: undefined,
                    clearTypeahead: true,
                },
                () => {
                    this.props.updateProductSourcesFn(this.state.productSources);
                }
            );
        }
    };

    removeItem = (source: ICatalog_Item) => {
        const productSources = this.state.productSources;

        let index = 0;
        let foundIndex = -1;
        for (const productSource of productSources) {
            if (productSource.guid === source.guid) {
                foundIndex = index;
            }

            index++;
        }

        if (foundIndex >= 0) {
            productSources.splice(foundIndex, 1);
        }

        this.setState(
            {
                productSources,
            },
            () => {
                this.props.updateProductSourcesFn(this.state.productSources);
            }
        );
    };

    clearTypeahead = () => {
        this.setState({
            selectedProductSource: undefined,
            clearTypeahead: false,
        });
    };

    render() {
        return (
            <div className="ProductSourcesDetail">
                <div className={"d-flex flex-row"}>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.typeaheadProductSources}
                        typeaheadItems={this.state.typeaheadItems}
                        titleProp={"sku"}
                        subTitleProp={"manufacturer"}
                        selectedItemFn={this.selectedItem}
                        selectedItemTitleProp={"sku"}
                        clearTypeaheadCallback={this.clearTypeahead}
                        clearTypeahead={this.state.clearTypeahead}
                    />

                    <div>
                        <OwButton title={"add"} fn={this.addSelectedItem} />
                    </div>
                </div>

                <div>
                    {this.state.productSources.map((source: ICatalog_Item, index: number) => {
                        return (
                            <div className={"d-flex p-1 align-items-center"} key={index}>
                                <i
                                    className={"fas fa-trash-alt text-danger pointer me-2"}
                                    onClick={() => {
                                        this.removeItem(source);
                                    }}
                                />{" "}
                                {source.manufacturer} {source.sku}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default ProductSourcesDetail;
